import createWorkerFunction from "../../createWorkerFunction.js";
import createWorkerInBrowser from "../../environment/createWorkerInBrowser.js";
export default function createWorkerFunctionInBrowser(fnOrAlias) {
    return createWorkerFunction(createWorkerInBrowser, fnOrAlias);
}
